var map = {
	"./Book Launch Event - 10 - 1080_1080.webp": 3037,
	"./Club Event - 2 - 1080_1080.webp": 2556,
	"./College Event - 6 - 1080_1080.webp": 9015,
	"./Concert & Live Shows - 4 - 1080_1080.webp": 4854,
	"./Cooking Show - 2 - 1080_1080.webp": 1769,
	"./Cultural Festival Event - 13 - 1080_1080.webp": 5350,
	"./Fashion Show - 2 - 1080_1080.webp": 3697,
	"./Government Event - 5 - 1080_1080.webp": 2866,
	"./Kitty Party - 6 - 1080_1080.webp": 4117,
	"./Mall Promotions & Activity Event - 14 - 1080_1080.webp": 7466,
	"./Movie Promotion Event - 15 - 1080_1080.webp": 7017,
	"./NGO And Charity Event - 4 - 1080_1080.webp": 4881,
	"./Other Event Banner - 6 - 1920_1080.webp": 7859,
	"./Outdoor Event - 7 - 1080_1080.webp": 7085,
	"./School Event - 2 - 1080_1080.webp": 8512,
	"./Sports Event - 5 - 1080_1080.webp": 2598,
	"./Talent Hunt Show - 13 - 1080_1080.webp": 2102,
	"./Valentine Day - 6 - 1080_1080.webp": 6706,
	"./Why Choose Panthi Event - 2 - 1280_720.webp": 6737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2215;